export default __webpack_public_path__ + "static/media/Agent_Role.72496acd.svg";